import { OrderItem } from "../../../../../../interfaces/Catalogue";
import OrderMenuArticle from "./OrderMenuArticle/OrderMenuArticle";

interface OrderMenuArticlesProps {
  menuArticles: OrderItem[];
  orderType: number;

  orderItemIndex: number;
  categoryItemId: number;
  orderCategoryItemQuantity: number;

  restaurantId: number;
  canApplyArticleDiscount: boolean;
  rewardClaimDisabled?: boolean;
  userLoyalityPoints?: number;
  totalLoyaltyPtsConsomed?: number;

}

const OrderMenuArticles = (props: OrderMenuArticlesProps) => {
  const {
    orderItemIndex,
    menuArticles,
    orderType,
    canApplyArticleDiscount,
    rewardClaimDisabled,
    categoryItemId,
    orderCategoryItemQuantity,
    restaurantId,
    userLoyalityPoints,
    totalLoyaltyPtsConsomed,
  } = props;

  return (
    <>
      {menuArticles?.map((order,index) => {
        if (order?.selectedArticles?.length > 0) {
          return (
            <div className="menu-content">
              <div className="menu-content-wrapper">
                <div className="menu-list">
                  <p className="menuItemName">{order?.level?.name}</p>
                  {order?.selectedArticles?.map((article) => {
                    return (
                      <OrderMenuArticle
                        categoryItemId={categoryItemId}
                        currentArticle={article}
                        orderItemIndex={orderItemIndex}
                        orderType={orderType}
                        canApplyArticleDiscount={canApplyArticleDiscount}
                        rewardClaimDisabled={rewardClaimDisabled}
                        restaurantId={restaurantId}
                        userLoyalityPoints={userLoyalityPoints}
                        totalLoyaltyPtsConsomed={totalLoyaltyPtsConsomed}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          );
        }
      })}
    </>
  );
};

export default OrderMenuArticles;
